import React from 'react';
import { Card, Switch, Space, Button, Typography } from 'antd';

const { Text } = Typography;

const Mobile = ({ viewModel }) => {
    const { enabled, setEnabled, onSave } = viewModel;

    return (
        <Card title="Cấu hình bảng giá" size="small">
            <Space direction="vertical" size={12} style={{ width: '100%' }}>
                <Space>
                    <Switch checked={enabled} onChange={setEnabled} />
                    <Text>{enabled ? 'Đã bật' : 'Đã tắt'}</Text>
                </Space>
                <Text type="secondary" style={{ fontSize: 12 }}>
                    Khi bật, giá sản phẩm sẽ theo bảng giá của khách hàng.
                </Text>
                <Button type="primary" block onClick={onSave}>Lưu</Button>
            </Space>
        </Card>
    );
};

export default Mobile;
